import React from "react";
import { Step } from "material-ui/Stepper";

export default class CustomStep extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { style = {}, completed, key, active } = this.props;
        return (
            <Step
                {...this.props}
                completed={completed}
                active={active}
                //eg : key={`trackWF-${i}`}
                key={key}
                style={Object.assign({}, style)}
            />
        );
    }
}
